import { Controller } from "@hotwired/stimulus"

// Whole-row navigation for console index tables (resources with row_click). The row
// carries the destination in a url value; clicks on real interactive elements inside
// the row (checkboxes, links, buttons) still do their own thing.
export default class extends Controller {
  static values = { url: String }

  visit(event) {
    if (event.target.closest("a, button, input, label, select, textarea")) return
    window.Turbo ? window.Turbo.visit(this.urlValue) : (window.location = this.urlValue)
  }
}
